import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isLegalPage = location.pathname === '/privacy-policy' || location.pathname === '/terms-of-service';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <RouterLink
          to="/"
          className="navbar-logo"
          style={{ cursor: 'pointer' }}
        >
          DTecX
        </RouterLink>

        {!isLegalPage && (
          <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
